module.exports = __webpack_public_path__ + "static/mobile_recruit_page_visual-aeaaa1debfd1d1e44dcea69d3a3ac76a.png";